<div class="text-box">
  <input type="text" [placeholder]="searchField ? 'Search' : ''" />
</div>
